














import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ inheritAttrs: false })
export default class FormSelect extends Vue {
  @Prop({ required: false, default: "" })
  label!: string;

  @Prop({ required: false, default: true })
  screenReaderLabel!: boolean;

  @Prop({ required: false, default: "" })
  inputClass!: string;

  @Prop({ required: true })
  options!: { [valueName: string]: string }; // e.g. { memory_usage: 'Memory usage' }

  // Default recommended for iOS
  // https://vuejs.org/v2/guide/forms.html#Select
  @Prop({ required: false, default: "" })
  defaultOption!: string; // e.g. "Select server"

  get screenReaderLabelClass() {
    return this.screenReaderLabel ? "screen-reader-text" : "";
  }

  updateValue(event: any) {
    this.$emit("input", event.target.value);
  }
}
